import * as React from "react";

import { connect } from "react-redux";
import Carrousel from "src/core/ui/carrousel";
import Divider from "src/core/ui/divider";
import { actions as homeActions } from "../../actions/home.actions";
import { actions } from "../../actions/main.actions";
import { actions as nameActions } from "../../actions/name.actions";
import ArtPreview from "../../core/ui/art-preview";
import Button from "../../core/ui/button";
import Calendar from "../../core/ui/calendar";
import Container from "../../core/ui/container";
import FullDescriptionLink from "../../core/ui/full-description-link";
import GenericDropDown from "../../core/ui/generic-dropdown";
import Grid, { Col, Row } from "../../core/ui/grid";
import InlineDescription from "../../core/ui/inline-description";
import Modal from "../../core/ui/modal";
import SimpleLinkComponent from "../../core/ui/simple-link";
import HttpService from "../../services/http.service";
import { LocationChangerProps } from "../App";
import News from "../arts/news-views";
import FooterView from "../footer/footer";
import TeamView from "./parts/team/team";

import DocumentMeta from "react-document-meta";
import Fade from "react-reveal/Fade";
import Slide from "react-reveal/Slide";
import PageTransition from "react-router-page-transition";
import Animated from "src/components/animations/animimated";
// import MetamaskRquiredComponent from "./parts/metamask";
import NavNotifier from "src/core/ui/nav-notifier";
import Player from "../../core/ui/player";
import RollingHome from "./parts/rolling-home";
import { resolve } from "inversify-react";
import FormInput from "src/core/ui/input";
import ToastService from "src/services/toast.service";
import images from "../../assets/images/index";
import HomeDataService from "./home.data.service";
import TeamMember from "./parts/team/team-member";
import { IApplicationState, Identity, IGalleryItem } from "../../typings";

interface IProps {
    name?: string;
    featuredArtist: IGalleryItem[];
    identity: Identity;
    location: any;
}

type HomeProps = IProps & typeof actions & typeof homeActions;

interface IState {
    time: Date;
    modalOpen: boolean;
    type: "light" | "dark";
    email: string;
    emailErrors?: string[];
}

class Home extends React.Component<HomeProps, IState> {
    @resolve
    public homeDataService: HomeDataService;

    @resolve
    public toastService: ToastService;

    public interval: any;

    constructor(props: any) {
        super(props);

        this.state = {
            time: new Date(Date.now()),
            modalOpen: false,
            type: "light",
            email: "",
        };
    }

    public componentDidMount() {
        this.props.changeLocation("home");
        this.props.loadFeatured();
    }

    public componentWillUnmount() {}

    public getStaticUrl = () => {
        return (window as any).SITE_CONFIG.baseUrl + (window as any).SITE_CONFIG.staticUrl;
    };

    public handleSubscription = () => {
        this.setState({ emailErrors: undefined });

        this.homeDataService
            .subscribe(this.state.email)
            .then((r) => {
                this.toastService.showToast("Subscription", "You have been subscribed to our newsletters", "success");
                this.setState({ email: "", emailErrors: [] });
            })
            .catch((error) => {
                this.toastService.showToast("Subscription", "Oops, we got an error with your subscription", "error");
                this.setState({ emailErrors: error.email });
            });
    };

    public render() {
        const mates = [
            {
                name: "Lorenzo Quinn",
                occupancy: "FOUNDER",
                email: "lorenzoquinn@finearttoken.com",
                image: images.lorenzoQuinn,
            },
            {
                name: "Nicholas Quinn",
                occupancy: "COO & CO-FOUNDER",
                email: "lorenzoquinn@finearttoken.com",
                image: images.nicholasQuinn,
            },
        ];

        const meta = {
            description: "Verify & certify your art work safely, using blockchain technology.",
            title: "Encrypto Art",
            meta: {
                property: {
                    // facebook
                    "og:type": "website",
                    "og:site_name": "encrypto.art",
                    "og:image": images.homeSculpt,
                    "og:title": "Encrypto Art",
                    "fb:app_id": "453598391709773",

                    // twitter
                    "twitter:title": "Encrypto Art",
                    "twitter:card": "summary_large_image",
                    "twitter:site": "@Fineart",
                    "twitter:image": images.homeSculpt,
                },
            },
        };

        return (
            <DocumentMeta {...meta}>
                <NavNotifier idk="white">
                    <div id="home" className="main-wapper">
                        <RollingHome
                            isAuthenticated={this.props.identity.isAuthenticated}
                            onStart={() => this.props.toggleLogin(true, 1)}
                        />
                    </div>
                </NavNotifier>

                <NavNotifier idk="white">
                    <Container className="no-padding" style={{ backgroundColor: "white", overflow: "hidden" }}>
                        {/*<Grid centered className="wrap" >
                                    {this.props.featuredArtist.map((item, index) =>{
                                        return (<Col size={25} key={`featured ${index}`}>
                                            <ArtPreview model={item}/>
                                        </Col>)
                                    })}

                                </Grid>*/}

                        <SimpleLinkComponent
                            id="why_us"
                            landing={true}
                            label="To Artists"
                            title="WHAT WE OFFER"
                            text="Our complete package offers the highest grade of security and ease for tokenising & protecting your artworks from fraud."
                        />
                        <Grid centered={true} fillRow={true}>
                            <Col size={25}>
                                <FullDescriptionLink
                                    image={images.dataIcon}
                                    title="DIGITAL PROTECTION"
                                    description="Artists can create Non-Fungible Token (NFT) certificates of authenticity for artworks through our easy-to-use interface."
                                />
                            </Col>
                            <Col size={25}>
                                <FullDescriptionLink
                                    image={images.touchIcon}
                                    title="PHYSICAL PROTECTION"
                                    description="Use Unique Secure Chips (USC) to link your physical artwork to its equivalent NFT Certificate in a tamper-proof way."
                                />
                            </Col>
                            <Col size={25}>
                                <FullDescriptionLink
                                    image={images.cryptIcon}
                                    title="PEER TO PEER"
                                    description="Access a network of collectors, galleries and artists. Trade peer-to-peer without intermediaries."
                                />
                            </Col>
                        </Grid>

                        {/* <SimpleLinkComponent id="for_artist" label="FOR ARTISTS"/> */}
                        <Grid centered={true}>
                            <Col size={40} className="side-bg" style={{ backgroundImage: `url('${images.giveTakeBackground}')` }}></Col>
                            <Col size={60} className="main-bg" style={{ backgroundImage: `url('${images.connectionsBackground}')` }}>
                                <div className="connection-description first-point">
                                    <h2>CERTIFY YOUR ART</h2>
                                    <h4>Create</h4>
                                    <Divider size="medium" />
                                    <p>
                                        Generate a Digital Certificate of Authenticity for your Artwork that is encrypted and linked to a
                                        high security decentralized ledger. We protect you against hacking attacks and fraudulent
                                        activities.
                                    </p>
                                </div>
                                <div className="connection-description second-point">
                                    <h2>VALIDATE AND MANAGE</h2>
                                    <h4>Verify</h4>
                                    <Divider size="medium" />
                                    <p>
                                        Validate and manage your artwork without intermediaries, avoiding unauthorized copies and
                                        distributions. Connect directly with your collectors and build credibility of your work.
                                    </p>
                                </div>
                                <div className="connection-description third-point">
                                    <h2>GIVE AND RECEIVE</h2>
                                    <h4>Transact</h4>
                                    <Divider size="medium" />
                                    <p>
                                        Send and receive digital certificates from anywhere in the world instantly and secured. Transactions
                                        can be traced to prove the origin of the certificate and bring transparency to The World of Fine
                                        Arts.
                                    </p>
                                </div>
                            </Col>
                        </Grid>
                    </Container>
                </NavNotifier>
                <NavNotifier idk="white">
                    <Container className="no-padding" style={{ backgroundColor: "white" }}>
                        <SimpleLinkComponent
                            id="our_vision"
                            landing={true}
                            label="Our Platform"
                            title="Learn about the founder’s inspiration behind"
                        />
                        <div className="vision">
                            <Player className="vision-video" url={"https://www.youtube.com/watch?v=90P2W-36Yeo&feature=youtu.be"} />
                        </div>
                    </Container>
                    <Container merged={true} className="no-padding" style={{ backgroundColor: "white" }}>
                        <div className="our-team">
                            <SimpleLinkComponent
                                id="our_team"
                                landing={true}
                                label="Meet Our Team"
                                title="DO YOU KNOW ABOUT OUR TEAM?"
                                text="The Encrypto Art team is comprised of some of the most inquisitive and ingenious minds in the art and blockchain industry, with many years of experience in our respective fields."
                            />
                            <div className="mates">
                                {mates.map((item, index) => (
                                    <TeamMember {...item} key={"mate" + index} />
                                ))}
                            </div>
                        </div>
                    </Container>
                </NavNotifier>

                <Container className="no-padding" style={{ backgroundColor: "white" }}></Container>

                <Container merged={true} className="no-padding stay-updated" style={{ backgroundColor: "white" }}>
                    <SimpleLinkComponent id="" landing={true} label="Our Newsletter" title="Sign up to" />
                    <Grid centered={true} fillRow={true} className="subcribe-form">
                        <Col size={50}>
                            <FormInput
                                value={this.state.email}
                                errors={this.state.emailErrors}
                                onChange={(e) => this.setState({ email: e })}
                                placeholder="Enter your email"
                                style="black"
                            />
                        </Col>
                        <Col size={10}>
                            <Button className="home-button" presentation="black" onClick={this.handleSubscription}>
                                SUBSCRIBE
                            </Button>
                        </Col>
                    </Grid>
                </Container>
            </DocumentMeta>
        );
    }
}

function mapStateToProps(state: IApplicationState, ownProps: any): any {
    return {
        ...ownProps,
        name: state.name,
        identity: state.identity,
        featuredArtist: state.featuredArtist,
    };
}

export default connect(mapStateToProps, { ...actions, ...nameActions, ...homeActions })(Home);



// WEBPACK FOOTER //
// ./src/components/home/home.tsx